import src from "IMAGE";
export default { src, width: 200, height: 50, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAANklEQVR42j3KMQoAIAwEwfzW2m8Kglgr6DeiuTNNnGqLFXHZEaCWSm2dMENyEmI4Y/Ku7Yk/PMu2JT1GidECAAAAAElFTkSuQmCC"};
